import Api from "lib/api";

import { toast } from "react-toastify";

const api = Api.getInstance();

const ns = "app/reset-password/";

export const RESET_START = ns + "RESET_START";
export const RESET_SUCCESS = ns + "RESET_SUCCESS";
export const RESET_FAILURE = ns + "RESET_FAILURE";

export function doReset (resetData, history) {
    return async (dispatch) => {
        dispatch({
            type: RESET_START
        });

        try {
            const response = await api.post('users/reset-password', resetData);
            const { data } = response;

            if (data.success) {
                toast.success('Your password has been reset!');

                dispatch({
                    type: RESET_SUCCESS
                });

                history.push('/');
            } else {
                toast.error('Unable to reset password.');

                dispatch({
                    type: RESET_FAILURE,
                    payload: data.errors
                });
            }

        } catch (error) {
            toast.error('Unable to reset password: ' + error.message);

            dispatch({
                type: RESET_FAILURE,
                payload: error.message
            });
        }
    };
};


// WEBPACK FOOTER //
// ./src/components/app/reset-password/actions.js